import { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../../../Components/Button/Button';

const ModalMacroubicaciones = (props) => {
	const {onHide, datosModal,  ...rest } = props;
   



	return (
		<Modal
			{...props}
			size="md"
			centered
			keyboard="false"
		>
			<Modal.Header>
        <h5 className="modal-title">
          <span>Detalle Macroubicaciones</span>
            <br/>
            <span>{datosModal.indicador.sigla} - {datosModal.exigencia.sigla}</span>
                  
        </h5>
				<Button type="button" design="btn-outline-pewter-blue p-2 lh-1 fs-3" onClick={() => {onHide();}}><i className='ico-close'></i></Button>
			</Modal.Header>
			<Modal.Body className='p-4 gap-4 d-flex flex-column'>
                
                <div className='accordion-body p-0 brd-top'>
                    <table className="table table-sm" style={{ width: "100%", textAlign: "left" }}>
                        <thead>
                        <tr>
                            <th>Macroubicación</th>
                            <th>Km Inicial</th>
                            <th>Km Final</th>
                        </tr>
                        </thead>
                        <tbody>
                        {datosModal.macroubicaciones.map((row) => (
                            <tr key={row.planMacroubicacionId}>
                              
                                
                                <td>{row.idMacroubicacion}</td>
                                <td>{row.pkInicial}</td>
                                <td>{row.pkFinal}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>
            
                <div className=" d-block mt-3">
                    <Button onClick={onHide} design="btn-primary" >Cerrar</Button>
                </div>
               
                    
			</Modal.Body>
		</Modal>
	)
}

export default ModalMacroubicaciones
